import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { createContactCategory } from '../api/contactCategories';
import type { ContactCategoryFormValues } from '../types';

export function useCreateContactCategory(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ContactCategoryFormValues) => createContactCategory(data),
    onSuccess: () => {
      notification.success({ message: 'Contact category created successfully' });
      void queryClient.invalidateQueries({ queryKey: ['settings-contact-categories'] });
      void queryClient.invalidateQueries({ queryKey: ['contact-categories'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to create contact category' });
    },
  });
}
